import React, { useState, useEffect, useRef } from 'react';
import {
    TextField, Button, Box, List, ListItem, Typography, Paper, Table, TableBody,
    TableCell, TableContainer, TableRow, Avatar, Dialog, DialogTitle, DialogContent,
    DialogActions, DialogContentText
} from '@mui/material';
import imagenLogo from '../../../img/injupemplogo.png';
import SendIcon from '@mui/icons-material/Send';
import { ContextSession } from "../../../services/ContextSession";
import { useContext } from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import nuevoMensaje from './nuevo mensaje.mp3';

function VerConsultaChatJefe() {
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState('');
    const [isClosed, setIsClosed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    let sessi = useContext(ContextSession);
    const messagesEndRef = useRef(null);
    const audioRef = useRef(new Audio(nuevoMensaje));

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);


    const fetchMessages = async () => {
        try {
            const ticketId = sessi.getVariable("SolicitudChatbot");
            const response = await fetch(`https://chatbot.injupemp.gob.hn/obtener_historial_mensajes/${ticketId}/`);
            const data = await response.json();
            if (data.historial) {
                const formattedMessages = data.historial.map((item) => ({
                    user: item.remitente === 'Agente' ? 'INJUPEMP' : selectedTicket?.nombre.toUpperCase() || 'Usuario desconocido',
                    text: item.mensaje,
                    timestamp: item.fecha_hora !== 'Desconocido' ? item.fecha_hora : 'Fecha desconocida',
                }));

                setMessages((prevMessages) => {
                    if (JSON.stringify(prevMessages) !== JSON.stringify(formattedMessages)) {
                        // Detectar si el nuevo mensaje es de un usuario (no enviado por INJUPEMP)
                        if (formattedMessages.length > prevMessages.length) {
                            const lastMessage = formattedMessages[formattedMessages.length - 1];
                            /*if (lastMessage.user !== 'INJUPEMP') {
                                audioRef.current.play(); // Reproducir sonido
                            }*/
                        }
                        return formattedMessages;
                    }
                    return prevMessages;
                });
            }
        } catch (error) {
            console.error('Error fetching messages:', error);
        }
    };

    useEffect(() => {
        const fetchTicketData = async () => {
            try {
                const ticketId = parseInt(sessi.getVariable("SolicitudChatbot"));
                const response = await fetch(`https://chatbot.injupemp.gob.hn/obtener_ticket_por_id/?id=${ticketId}`);
                const data = await response.json();
                const ticket = data.tickets.find(t => t.id === ticketId);
                if (ticket) {
                    setSelectedTicket(ticket);
                    if (ticket.estado.toLowerCase() === 'cerrado') {
                        setIsClosed(true);
                    }
                }
            } catch (error) {
                console.error('Error fetching ticket data:', error);
            }
        };

        fetchTicketData();
    }, [sessi]);

    useEffect(() => {
        if (selectedTicket) {
            fetchMessages(); // Carga los mensajes al menos una vez
        }

        if (!isClosed) { // Configura el intervalo solo si no está cerrado
            const interval = setInterval(fetchMessages, 5000);
            return () => clearInterval(interval);
        }
    }, [selectedTicket, isClosed]); // Dependencias incluyen selectedTicket e isClosed


    const sendMessage = async () => {
        if (message.trim() === '') {
            alert('El campo de mensaje no puede estar vacío.');
            return;
        }

        setIsLoading(true);

        try {
            const response = await fetch('https://chatbot.injupemp.gob.hn/responder_ticket/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    agente_id: sessi.sessionData.id,
                    ticket_id: sessi.getVariable("SolicitudChatbot"),
                    mensaje: message,
                }),
            });

            if (response.ok) {
                setMessages([...messages, { user: 'INJUPEMP', text: message, timestamp: new Date().toLocaleString() }]);
                setMessage('');
            } else {
                alert('Error al enviar el mensaje. Por favor, inténtalo de nuevo.');
            }
        } catch (error) {
            console.error('Error sending message:', error);
            alert('Ocurrió un error al enviar el mensaje.');
        } finally {
            setIsLoading(false);
        }
    };

    const closeRequest = async () => {
        try {
            const ticketId = sessi.getVariable("SolicitudChatbot");
            await fetch(`https://chatbot.injupemp.gob.hn/cerrar_ticket/${ticketId}/`, {
                method: 'POST',
            });
            setDialogOpen(true); // Muestra un mensaje indicando que se cerró la solicitud
        } catch (error) {
            console.error('Error closing ticket:', error);
        }
    };

    const handleConfirmClose = () => {
        setConfirmDialogOpen(false); // Cierra el diálogo de confirmación
        closeRequest(); // Llama a la función para cerrar la solicitud
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setIsClosed(true);
    };

    const renderMessages = () => {
        return messages.map((msg, index) => (
            <ListItem key={index} sx={{ display: 'flex', justifyContent: msg.user === 'INJUPEMP' ? 'flex-end' : 'flex-start' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {msg.user !== 'INJUPEMP' && (
                        <Avatar sx={{ backgroundColor: 'grey', marginRight: 1 }} />
                    )}
                    {msg.user === 'INJUPEMP' && (
                        <img src={imagenLogo} alt="Call Center" style={{ width: '64px', height: '34px', marginRight: 5 }} />
                    )}
                    <Paper
                        sx={{
                            padding: '10px',
                            backgroundColor: msg.user !== 'INJUPEMP' ? '#c8e6c9' : '#e0f7fa',
                            marginBottom: '10px',
                            borderRadius: '8px',
                            boxShadow: 2,
                            wordWrap: 'break-word',
                            whiteSpace: 'normal',
                            overflowWrap: 'break-word',
                            wordBreak: 'break-word',
                            display: 'inline-block',
                        }}
                    >
                        <Typography variant="caption" style={{ fontSize: 14, fontWeight: 'bold' }}>
                            {msg.user}:
                        </Typography>
                        <Typography variant="body2" style={{ fontSize: 17 }}>{msg.text}</Typography>
                        <Typography variant="caption" color="textSecondary" style={{ fontSize: 14 }}>{msg.timestamp}</Typography>
                    </Paper>
                </Box>
            </ListItem>
        ));
    };

    return (
        <>
            <Typography variant="h4" fontWeight="bold" align="center" gutterBottom marginTop={5}>
                Solicitud #{sessi.getVariable("SolicitudChatbot")} - INJUPEMP Virtual
            </Typography>

            <Box sx={{ padding: 3, maxWidth: 900, margin: 'auto', backgroundColor: '#f5f5f5', borderRadius: '12px', boxShadow: 3, marginTop: 3 }}>
                <Typography variant="h5" gutterBottom align="center"><b>Datos De La Persona:</b></Typography>

                <TableContainer sx={{ marginBottom: 2 }} component={Paper}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell><Typography variant="subtitle1" fontWeight="bold">Nombre:</Typography></TableCell>
                                <TableCell>{selectedTicket?.nombre?.toUpperCase() || 'Cargando...'}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><Typography variant="subtitle1" fontWeight="bold">Identidad:</Typography></TableCell>
                                <TableCell>{selectedTicket?.dni || 'Cargando...'}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><Typography variant="subtitle1" fontWeight="bold">Teléfono:</Typography></TableCell>
                                <TableCell>{selectedTicket?.telefono || 'Cargando...'}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><Typography variant="subtitle1" fontWeight="bold">Teléfono Alterno:</Typography></TableCell>
                                <TableCell>{selectedTicket?.telefono_alterno ?? 'NA'}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><Typography variant="subtitle1" fontWeight="bold">Estado de la Solicitud:</Typography></TableCell>
                                <TableCell>{selectedTicket?.estado.toUpperCase() || 'Cargando...'}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <Typography variant="h5" gutterBottom align="center"><b>Conversación:</b></Typography>

                <List sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {renderMessages()}
                    <div ref={messagesEndRef} />
                </List>


                {/*!isClosed && (
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', marginTop: 2 }}>
                        <TextField
                            label="Escribe un mensaje"
                            fullWidth
                            multiline
                            variant="outlined"
                            value={message}
                            onChange={(e) => {
                                const input = e.target.value;
                                // Capitaliza solo la primera letra sin afectar el resto del texto
                                const formattedInput = input.charAt(0).toUpperCase() + input.slice(1);
                                setMessage(formattedInput);
                            }}
                            disabled={isClosed || isLoading}
                            sx={{
                                borderRadius: '20px',
                                '& .MuiOutlinedInput-root': { borderRadius: '20px' },
                            }}
                            inputProps={{
                                spellCheck: true, // Activar corrección ortográfica
                                lang: 'es', // Configuración del idioma en español
                            }}
                        />



                        <Button
                            variant="contained"
                            color="success"
                            onClick={sendMessage}
                            disabled={isClosed || isLoading}
                            sx={{ borderRadius: '18px' }}
                            endIcon={<SendIcon />}
                        >
                            {isLoading ? 'Enviando...' : 'Enviar'}
                        </Button>
                    </Box>
                )*/}

                {/*!isClosed && (
                    <Box sx={{ marginTop: 2 }}>
                        <Button
                            variant="outlined"
                            color="error"
                            fullWidth
                            onClick={() => setConfirmDialogOpen(true)} // Abre el diálogo de confirmación
                            sx={{
                                borderRadius: '10px',
                                '&:hover': { backgroundColor: '#d32f2f', color: 'white' }
                            }}
                        >
                            Finalizar Solicitud
                        </Button>
                    </Box>
                )*/}

                {isClosed && (
                    <Box sx={{ marginTop: 2 }}>
                        <Typography variant="body1" color="textSecondary" align="center">
                            La solicitud está cerrada.
                        </Typography>
                    </Box>
                )}
            </Box>

            <Dialog open={dialogOpen} onClose={handleDialogClose}>
                <DialogTitle style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CheckCircleIcon style={{ color: 'green', marginRight: '8px', verticalAlign: 'middle' }} />
                    Solicitud Cerrada
                </DialogTitle>
                <DialogContent>
                    <Typography>La solicitud fue cerrada con éxito.</Typography>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <Button onClick={handleDialogClose} color="primary" variant="contained">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialogo de confirmación */}
            <Dialog
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogTitle id="confirm-dialog-title" sx={{ textAlign: 'center' }}>
                    Confirmar
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description">
                        ¿Está seguro de que desea cerrar la solicitud?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                        onClick={() => setConfirmDialogOpen(false)}
                        color="error"
                        variant="contained"
                        endIcon={<Cancel />}
                    >
                        No
                    </Button>
                    <Button
                        onClick={handleConfirmClose}
                        color="success"
                        variant="contained"
                        endIcon={<CheckCircleIcon />}
                        autoFocus
                    >
                        Sí
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default VerConsultaChatJefe;